const layout = () => import('../../internal/dashboard/layoutV2.vue')
const faturamento = () => import('./faturamento.vue')
const faturamentoDetalhe = () => import('./faturamento-detalhe.vue')

const faturamentoRoutes = {
  component: layout,
  children: [
    {
      path: '/invoicing',
      name: 'faturamento',
      component: faturamento,
      meta: {
        title: 'faturamento',
        requiresAuth: true,
      },
    },
    {
      path: '/invoicing/:id',
      name: 'faturamentoDetalhePage',
      component: faturamentoDetalhe,
      meta: {
        title: 'faturamentoDetalhe',
        requiresAuth: true,
      },
    },
  ],
}

export default faturamentoRoutes
